/**
 * The usage page's remembered metric and window, persisted per device.
 *
 * Ported from upstream's `usagePagePreferences.ts` (pingdotgg/t3code, MIT,
 * pin e3e7cc3f) with two forge deltas: the metric axis carries cost and
 * tokens only (forge has no quota-limits view, which is upstream's default),
 * so the remembered default is cost over 30 days, and the storage key is
 * forge-prefixed. A malformed or missing preference falls back to the
 * default rather than to whatever the JSON happened to carry.
 *
 * @module
 */

import * as Schema from "effect/Schema";

import { getLocalStorageItem, setLocalStorageItem } from "../../hooks/useLocalStorage";

const STORAGE_KEY = "forge:usage-page-preferences:v1";

const UsagePagePreferencesSchema = Schema.Struct({
  metric: Schema.Literals(["cost", "tokens"]),
  windowDays: Schema.Literals([1, 7, 30, 90]),
});

export type UsagePagePreferences = typeof UsagePagePreferencesSchema.Type;

const DEFAULT_PREFERENCES: UsagePagePreferences = { metric: "cost", windowDays: 30 };

export function readUsagePagePreferences(): UsagePagePreferences {
  try {
    return getLocalStorageItem(STORAGE_KEY, UsagePagePreferencesSchema) ?? DEFAULT_PREFERENCES;
  } catch (error) {
    console.error("Could not read Usage page preferences.", error);
    return DEFAULT_PREFERENCES;
  }
}

export function saveUsagePagePreferences(preferences: UsagePagePreferences): void {
  try {
    setLocalStorageItem(STORAGE_KEY, preferences, UsagePagePreferencesSchema);
  } catch (error) {
    console.error("Could not save Usage page preferences.", error);
  }
}
